import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./TruckOfflading.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import nkLogo from "../../src/assets/NK LOGO.jpg";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function TruckOfflading({ setPage }) {

    useEffect(() => {
    
      trackPageVisit("TruckOfflading");
    
    }, []);
  
     const {  valves, toggleValve, transmitters, updateTransmitter} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);
  const {processData,  setProcessData} = useContext(ProcessContext);



     

  const DEFAULT_VALVES = {
  FCV_1201: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("TruckOfflading_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1201: { ...DEFAULT_VALVES.FCV_1201, ...parsed.FCV_1201 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("TruckOfflading_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);



const [InflowTruckBBL, setInflowTruckBBL] = useState(() => {

  const saved = localStorage.getItem(
    "TruckOffloading_InflowTruckBBL"
  );

  return saved !== null
    ? Number(saved)
    : 284;

});


useEffect(() => {

localStorage.setItem(
  "TruckOffloading_InflowTruckBBL",
  JSON.stringify(InflowTruckBBL)
);

}, [InflowTruckBBL]);


/* ====================================================
   TRUCK MOVEMENT STATES
==================================================== */

const [truckPosition, setTruckPosition] = useState(() => {
  const saved = localStorage.getItem("truckPosition");

  return saved
    ? JSON.parse(saved)
    : { left: -900, top: 320 };
});

const [isArrived, setIsArrived] = useState(() => {
  return JSON.parse(
    localStorage.getItem("isArrived") || "false"
  );
});

const [truckMoving, setTruckMoving] = useState(false);

const [rotation, setRotation] = useState("0deg");

const [truckVisible, setTruckVisible] = useState(true);

/* ====================================================
   TRUCK INVENTORY
==================================================== */





// ================= TRUCK MOVEMENT =================

const handleTruckMovement = () => {

  // ================= ARRIVAL =================

  if (!isArrived) {

    setTruckMoving(true);

    setTruckVisible(true);

    setTruckPosition({
      left: 250,
      top: 320
    });

    setTimeout(() => {

      setTruckMoving(false);

      setIsArrived(true);

      setTruckVisible(true);

    }, 8000);

  }

  // ================= DEPARTURE =================

  else {

    setTruckMoving(true);

    setTruckPosition({
      left: 1800,
      top: 320
    });

    setTimeout(() => {

      setTruckMoving(false);

      setIsArrived(false);

      setTruckVisible(false);

      // Reset truck offscreen for next arrival
      setTruckPosition({
        left: -900,
        top: 320
      });

    }, 8000);

  }

};






useEffect(() => {

  localStorage.setItem(
    "truckPosition",
    JSON.stringify(truckPosition)
  );

}, [truckPosition]);



useEffect(() => {

  localStorage.setItem(
    "isArrived",
    JSON.stringify(isArrived)
  );

}, [isArrived]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




  const xv1201Open = !valves?.XV_1201;
  const xv1202Open = !valves?.XV_1202;



  /* =========================================================
   PUMP CONTEXT
========================================================= */
const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});


/* =========================================================
   LOW LEVEL TRIP
========================================================= */
const lowLowLevelTrip =
  InflowTruckBBL <= 1;

/* =========================================================
   TRUCK NOT ARRIVED TRIP
========================================================= */
const departureTrip =
  !isArrived;

/* =========================================================
   PUMP STATUS
========================================================= */
const isP1201AOn =
  pumpData?.["P-1201A"]?.running ?? false;

const isP1201BOn =
  pumpData?.["P-1201B"]?.running ?? false;

/* =========================================================
   AUTO TRIP ACTION
========================================================= */
useEffect(() => {

  if (
    lowLowLevelTrip ||
    departureTrip
  ) {

    if (
      pumpData?.["P-1201A"]?.running
    ) {
      togglePump("P-1201A");
    }

    if (
      pumpData?.["P-1201B"]?.running
    ) {
      togglePump("P-1201B");
    }

  }

}, [
  lowLowLevelTrip,
  departureTrip,
  pumpData,
  togglePump
]);

/* =========================================================
   EFFECTIVE PUMP STATUS
========================================================= */
const P1201A_Active =
  isP1201AOn &&
  xv1201Open &&
  !lowLowLevelTrip &&
  !departureTrip;

const P1201B_Active =
  isP1201BOn &&
  xv1202Open &&
  !lowLowLevelTrip &&
  !departureTrip;

/* =========================================================
   SYSTEM CAPACITY
========================================================= */
const TOTAL_CAPACITY = 0.967;

/* =========================================================
   CONTROL VALVE
========================================================= */
const fcvOpening =
  Number(
    valveData?.FCV_1201?.opening || 0
  );

/* =========================================================
   RUNNING PUMPS
========================================================= */
const activePumpCount =
  [
    P1201A_Active,
    P1201B_Active
  ].filter(Boolean).length;

/* =========================================================
   FLOW CONTRIBUTION
========================================================= */
const P1201A_Flow =
  P1201A_Active
    ? (
        TOTAL_CAPACITY *
        (fcvOpening / 100)
      ) / activePumpCount
    : 0;

const P1201B_Flow =
  P1201B_Active
    ? (
        TOTAL_CAPACITY *
        (fcvOpening / 100)
      ) / activePumpCount
    : 0;

/* =========================================================
   TOTAL FLOW
========================================================= */
const targetFlow =
  P1201A_Flow +
  P1201B_Flow;

/* =========================================================
   FLOW INDICATOR (DCS SMOOTHING)
========================================================= */
const FIC_1201 = processData.FIC_1201 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1201_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1201 || 0);

    const systemActive =
      P1201A_Active ||
      P1201B_Active;

    const target =
      systemActive
        ? targetFlow
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1201: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFlow,
  P1201A_Active,
  P1201B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1201_LastUpdate",
    String(Date.now())
  );

}, [FIC_1201]);




useEffect(() => {

  const interval = setInterval(() => {

    setProcessData(prev => {

      const systemActive =
        P1201A_Active ||
        P1201B_Active;

      const currentFlow =
        Number(prev.FIC_1201 || 0);

      let newFlow = currentFlow;

      if (
        !systemActive ||
        targetFlow === 0 ||
        lowLowLevelTrip ||
        departureTrip
      ) {

        newFlow =
          currentFlow +
          (0 - currentFlow) * 0.12;

      } else {

        newFlow =
          currentFlow +
          (
            targetFlow -
            currentFlow
          ) * 0.12;

      }

      return {
        ...prev,
        FIC_1201: Number(
          newFlow.toFixed(3)
        )
      };

    });

  }, 100);

  return () => clearInterval(interval);

}, [
  targetFlow,
  P1201A_Active,
  P1201B_Active,
  lowLowLevelTrip,
  departureTrip,
  setProcessData
]);

/* =========================================================
   PRESSURE
========================================================= */
const PT_1201 =
  (
    P1201A_Active ||
    P1201B_Active
  )
    ? 1.8
    : 0;

/* =========================================================
   TEMPERATURE
========================================================= */
const TT_1201 =
  (
    P1201A_Active ||
    P1201B_Active
  )
    ? 37
    : 28;

/* =========================================================
   GENERAL STATUS
========================================================= */
const isTruckPumpRunning =
  P1201A_Active ||
  P1201B_Active;


  /* =========================================================
   STARTUP ELAPSED-TIME CATCH-UP
========================================================= */

useEffect(() => {

  const now = Date.now();

  const elapsedSeconds =
    (now - lastProcessTimeRef.current) / 1000;

  // ✅ READ SAVED FLOW
  const savedFlow =
    Number(
      localStorage.getItem(
        "TruckOfflading_FIC_1201"
      )
    ) || 0;

  if (
    elapsedSeconds > 0 &&
    savedFlow > 0.04
  ) {

    const missedVolume =
      savedFlow * elapsedSeconds;

    // ✅ RECOVER TOTALIZER
    setFIQ_1201(prev =>
      Number(
        (prev + missedVolume).toFixed(3)
      )
    );

    // ✅ RECOVER INVENTORY
    setInflowTruckBBL(prev => {

      const next =
        prev - missedVolume;

      return next > 0
        ? Number(next.toFixed(3))
        : 0;

    });

  }

  lastProcessTimeRef.current = now;

}, []);




/* =========================================================
   FIQ + INVENTORY PERSISTENT STORAGE
========================================================= */

const [FIQ_1201, setFIQ_1201] = useState(() => {

  return Number(
    localStorage.getItem("FIQ_1201")
  ) || 0;

});

const lastProcessTimeRef = useRef(
  Number(
    localStorage.getItem(
      "TruckOfflading_lastProcessTime"
    )
  ) || Date.now()
);


/* =========================================================
   NORMAL TOTALIZING
========================================================= */

useEffect(() => {

  const interval = setInterval(() => {

    if (FIC_1201 > 0.04) {

      setFIQ_1201(prev =>
        Number(
          (prev + FIC_1201).toFixed(3)
        )
      );

      setInflowTruckBBL(prev => {

        const next =
          prev - FIC_1201;

        return next > 0
          ? Number(next.toFixed(3))
          : 0;

      });

    }

    lastProcessTimeRef.current = Date.now();

  }, 1000);

  return () => clearInterval(interval);

}, [FIC_1201]);



/* =========================================================
   SAVE PERSISTENT DATA
========================================================= */

useEffect(() => {

  localStorage.setItem(
    "FIQ_1201",
    JSON.stringify(FIQ_1201)
  );

localStorage.setItem(
  "TruckOffloading_InflowTruckBBL",
  JSON.stringify(InflowTruckBBL)
);

  localStorage.setItem(
  "TruckOfflading_lastProcessTime",
  String(lastProcessTimeRef.current)
);

}, [
  FIQ_1201,
  InflowTruckBBL,
  lastProcessTimeRef
]);


/* =========================================================
   RESET TOTALIZER
========================================================= */

const resetFIQ1201 = () => {

  const now = Date.now();

  setFIQ_1201(0);

  lastProcessTimeRef.current = now;

  localStorage.setItem(
    "FIQ_1201",
    JSON.stringify(0)
  );

  localStorage.setItem(
    "TruckOfflading_lastProcessTime",
    String(now)
  );

};







useEffect(() => {

  localStorage.setItem(
    "TruckOfflading_FIC_1201",
    JSON.stringify(FIC_1201)
  );

}, [FIC_1201]);




useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1201 === FIC_1201  
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1201,
    }
  });

}, [FIC_1201, ]);






              /* 🔥 ALARM ENGINE TAGS */
        
                const { evaluateTag } = useContext(AlarmContext);
        
                useEffect(() => {
                  evaluateTag("PT_1201", PT_1201);
                  

                }, [PT_1201, ]);
                







  return (
    <div className="TruckOfflading-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "245px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 243px",
          zIndex: 10,
        }}
      >
        CRUDE TRUCK OFFLOADING GANTRY
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1201 */}
      <Valve
        className="XV-1201"
        tag="XV_1201"
        x={761}
        y={148}
        isClosed={valves.XV_1201}
        toggle={toggleValve}
      />

      {/* XV-1202 */}
      <Valve
        className="XV-1202"
        tag="XV_1202"
        x={761}
        y={279}
        isClosed={valves.XV_1202}
        toggle={toggleValve}
      />


      



      
         {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1201 */}
        <div
            style={{ position: "absolute", left: 843, top: 138}}
            onMouseEnter={() => setHoveredValve("FCV_1201")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1201")}
          >

            {hoveredValve === "FCV_1201" && (
              <div style={tagStyle}>
                FCV_1201
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1201">
                    
          <defs>
            <linearGradient id="metal_1201">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1201)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1201)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



          {/* ================= MDS FACEPLATE ================= */}

          {showMDS && (
            <MDSFaceplate
              close={() => setShowMDS(false)}
              showBargeSelector={false}
            />
          )}

           

      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1201?.opening || 0)}
        x={861}
        y={184}
      />




      <button
        onClick={resetFIQ1201}
        style={{
          position: "absolute",
          top: "177px",
          left: "1050px",

          padding: "5px 2px",

          background: "#1101f8",
          color: "#fff",

          border: "none",
          borderRadius: "4px",

          fontWeight: "bold",
          cursor: "pointer",

        }}
      >
        RESET FIQ
      </button>





        <button
        onClick={handleTruckMovement}
        style={{
          position: "fixed",
          top: "300px",
          left: "20px",
          padding: "10px 30px",
          background: "#001eff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          fontWeight: "bold",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        {isArrived ? "Departure" : "Arrival"}
      </button>



        {/* ================= SVG RESIZE WRAPPER ================= */}
      <div
          style={{
            position: "absolute",
            left: truckPosition.left,
            top: truckPosition.top,
            width: "900px",
            height: "450px",
            transform: `scale(1) rotateY(${rotation})`,
            opacity: truckVisible ? 1 : 0,
            pointerEvents: truckVisible ? "auto" : "none",
            transformOrigin: "center center",
            transition: "left 8s linear, top 8s linear, transform 1s ease",
          }}
        >

      <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 2200 1000">

          <defs>

          <linearGradient id="tankMetal"
          x1="0%" y1="0%"
          x2="0%" y2="100%">

          <stop offset="0%" stop-color="#fefefe"/>
          <stop offset="25%" stop-color="#d9d9d9"/>
          <stop offset="50%" stop-color="#8ea2b8"/>
          <stop offset="75%" stop-color="#f0f0f0"/>
          <stop offset="100%" stop-color="#c4c4c4"/>

          </linearGradient>

          <linearGradient id="cabWhite"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%">

          <stop offset="0%" stop-color="#ffffff"/>
          <stop offset="100%" stop-color="#d7d7d7"/>

          </linearGradient>

          </defs>

          <g
                id="crudeTruck"
                transform="translate(2200,0) scale(-1,1)"
              >

          {/*  ====================================================== */}
          {/*  CAB --*/}
          {/*  ====================================================== */}

          <g id="cab">

          <path
          d="
          M120 620
          L120 430
          L230 360
          L470 280
          L620 280
          L620 620
          Z"
          fill="url(#cabWhite)"
          stroke="#777"
          stroke-width="4"/>

          {/*-- Door --*/}

          <rect
          x="380"
          y="300"
          width="180"
          height="260"
          rx="10"
          fill="#f7f7f7"
          stroke="#666"
          stroke-width="3"/>

         {/*-- Window --*/}

          <polygon
          points="
          400,320
          540,320
          540,450
          420,450
          400,430"
          fill="#5fb8ff"
          stroke="#2b5f8f"
          stroke-width="3"/>

          {/*-- Mirror --*/}

          <line
          x1="370"
          y1="350"
          x2="330"
          y2="340"
          stroke="#666"
          stroke-width="5"/>

          <rect
          x="300"
          y="325"
          width="35"
          height="25"
          fill="#999"/>

          {/*-- Headlight --*/}

          <ellipse
          cx="180"
          cy="540"
          rx="30"
          ry="22"
          fill="#fff7b3"
          stroke="#888"/>

          </g>

          {/* ====================================================== */}
          {/* TANK --*/}
          {/* ====================================================== */}

          <g id="tank">

          <rect
          x="650"
          y="260"
          width="1050"
          height="300"
          rx="150"
          fill="url(#tankMetal)"
          stroke="#999"
          stroke-width="4"/>

          {/* Reflective band */}

          <rect
          x="680"
          y="360"
          width="980"
          height="40"
          fill="#4f8ed7"
          opacity="0.45"/>

          {/* Tank rings */}

          <line x1="900" y1="260" x2="900" y2="560"
          stroke="#bdbdbd"
          stroke-width="3"/>

          <line x1="1150" y1="260" x2="1150" y2="560"
          stroke="#bdbdbd"
          stroke-width="3"/>

          <line x1="1400" y1="260" x2="1400" y2="560"
          stroke="#bdbdbd"
          stroke-width="3"/>

          </g>

          {/* ====================================================== */}
          {/* CHASSIS */}
          {/* ====================================================== */}

          <g id="chassis">

          <rect
          x="420"
          y="560"
          width="1350"
          height="35"
          fill="#2a2a2a"/>

          </g>

            <g id="chassis">

          <rect
          x="150"
          y="615"
          width="1620"
          height="105"
          fill="#2a2a2a"/>

          </g>

          {/* ====================================================== */}
          {/* STORAGE BOXES */}
          {/* ====================================================== */}

          <g id="boxes">

          <rect
          x="680"
          y="620"
          width="280"
          height="140"
          fill="#7d8895"/>

          <rect
          x="1000"
          y="620"
          width="280"
          height="140"
          fill="#7d8895"/>

          </g>

          {/* ====================================================== */}
          {/* PIPING */}
          {/* ====================================================== */}

          <g id="piping">

          <line
          x1="720"
          y1="590"
          x2="1650"
          y2="300"
          stroke="#c0c0c0"
          stroke-width="22"/>

          <line
          x1="590"
          y1="290"
          x2="1650"
          y2="576"
          stroke="#c0c0c0"
          stroke-width="22"/>

          <circle
          cx="980"
          cy="590"
          r="45"
          fill="#ff0000"/>

          <circle
          cx="1280"
          cy="590"
          r="45"
          fill="#ff0000"/>

          <circle
          cx="680"
          cy="590"
          r="45"
          fill="#ff0000"/>

          <circle
          cx="1630"
          cy="590"
          r="45"
          fill="#ff0000"/>

          </g>

          {/* ====================================================== */}
          {/* FRONT WHEEL */}
          {/* ====================================================== */}

          <g id="frontWheel" transform="translate(400 720)">
            <g className={truckMoving ? "wheel-spin" : ""}>
             <circle
          r="95"
          fill="#111"/>

          <circle
          r="70"
          fill="#b4b0b0"/>

          <circle
          r="18"
          fill="#666"/>

          <line x1="-60" y1="0" x2="60" y2="0"
          stroke="#06f712"
          stroke-width="5"/>

          <line x1="0" y1="-60" x2="0" y2="60"
          stroke="#888"
          stroke-width="5"/>

          <line x1="-45" y1="-45" x2="45" y2="45"
          stroke="#5e08fd"
          stroke-width="5"/>

          <line x1="-45" y1="45" x2="45" y2="-45"
          stroke="#888"
          stroke-width="5"/>

            </g>
          </g>



          {/* ====================================================== */}
          {/* REAR WHEEL */}
          {/* ====================================================== */}

          <g id="rearWheel" transform="translate(1450 720)">
            <g className={truckMoving ? "wheel-spin" : "5"}>
              <circle
          r="95"
          fill="#111"/>

          <circle
          r="70"
          fill="#cfcaca"/>

          <circle
          r="18"
          fill="#666"/>

          <line x1="-60" y1="0" x2="60" y2="0"
          stroke="#0307fa"
          stroke-width="5"/>

          <line x1="0" y1="-60" x2="0" y2="60"
          stroke="#888"
          stroke-width="5"/>

          <line x1="-45" y1="-45" x2="45" y2="45"
          stroke="#e1fa02"
          stroke-width="5"/>

          <line x1="-45" y1="45" x2="45" y2="-45"
          stroke="#888"
          stroke-width="5"/>
            </g>
          </g>
      
          </g>


          {/* ====================================================== */}
          {/* NK TECH LOGO */}
          {/* ====================================================== */}
            <image
                href={nkLogo}
                x="1645"
                y="420"
                width="160"
                height="100"
                transform="rotate(0 1080 380)"
                preserveAspectRatio="xMidYMid meet"
            />

          <text
          x="730"
          y="430"
          font-size="70"
          font-weight="900"
          fill="#003366">

          NK Tech Trucks

          </text>

          </svg>



          
        <div
          onMouseDown={handleMouseDown}
          style={{
            position: "absolute",
            top: panelPos.y,
            left: panelPos.x,
            zIndex: 2000,
            background: "black",
            padding: "10px",
            borderRadius: "6px",
            color: "white",
            cursor: "move",
            userSelect: "none",
          }}
        >
          <label style={{ fontSize: "12px" }}>
            Loaded BBL:
          </label>

          <input
            type="number"
            value={InflowTruckBBL}
            onChange={(e) =>
              setInflowTruckBBL(Number(e.target.value) || 0)
            }
            style={{ marginLeft: "8px" }}
          />

          <div style={{ marginTop: "5px", fontSize: "12px" }}>
            Truck Capacity (Litres): {Number(InflowTruckBBL).toFixed(2)*158.987}
          </div>
        </div>




        <button
          onClick={() => {
                  setShowMDS(true);
                }}
          style={{
            position: "fixed",
            top: "175px",
            left: "530px",
            padding: "10px 25px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 2000,
            boxShadow: "0 3px 8px rgba(0,0,0,0.4)"
          }}
        >
          MDS
        </button>


      </div>


          <Transmitter
            tag="FIC_1201"
            value={[FIC_1201]}
            x={925}
            y={185}
            unit="BPM"
            max={1}
            HH={0.95}
            H={0.8}
            L={0}
            LL={0}
            c="lime"
            description="FLOWRATE OF CRUDE FROM TRUCK DISCHARGE OF CRUDE UNLOADING TRANSFER PUMPS TO TANK FARM"
          />

          <Transmitter
            tag="PT_1201"
            value={[PT_1201]}
            x={925}
            y={129}
            unit="MPa"
            max={3}
            HH={2.5}
            H={2.0}
            L={0}
            LL={0}
            c="lime"
            description="PRESSURE OF CRUDE FROM TRUCK DISCHARGE OF CRUDE UNLOADING TRANSFER PUMPS TO TANK FARM"
          />

          <Transmitter
            tag="TT_1201"
            value={[TT_1201]}
            x={925}
            y={89}
            unit="°C"
            max={100}
            HH={80}
            H={60}
            L={20}
            LL={10}
            c="lime"
            description="TEMPERATURE OF CRUDE FROM TRUCK DISCHARGE OF CRUDE UNLOADING TRANSFER PUMPS TO TANK FARM"
          />

          <Transmitter
          tag="FIQ_1201"
          value={[FIQ_1201]}
          x={1050}
          y={134}
          unit="BBL"
          max={100000}
          HH={90000}
          H={80000}
          L={0}
          LL={0}
          c="cyan"
          description="TOTALIZED FLOW OF CRUDE TRANSFERRED FROM UNLOADING GANTRY TO CRUDE TANKS"
        />
  





            <Pump
              tag="P-1201A"
              x={649}
              y={154}
              rpm={1800}
              bladeCount={pumpData?.["P-1201A"]?.bladeCount || 3}
              size={pumpData?.["P-1201A"]?.size || 50}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1201B"
              x={649}
              y={286}
              rpm={1800}
              bladeCount={pumpData?.["P-1201B"]?.bladeCount || 3}
              size={pumpData?.["P-1201B"]?.size || 50}
              onClick={openPumpPanel}
            />




    </div>
  );
}

export default TruckOfflading;